<h1>{{valuesInject.product.name}}</h1>
<img src="{{valuesInject.product.image.url.default}}" alt="img" style="margin-bottom: 15px" />
<p>{{valuesInject.product.description}}</p>
